import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function FilterBar({
  query,
  onQueryChange,
  categories = [],
  activeCategory,
  onCategoryChange,
  sort,
  onSortChange,
  totalCount,
  playlistMode = false,
}) {
  return (
    <div className="space-y-6" data-testid="video-search-and-filter-bar">
      <div className="flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-between">
        <div className="relative flex-1 max-w-2xl">
          <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
          <Input
            data-testid="search-input"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Search the vault — titles, tags, hardware, games…"
            className="pl-11 pr-10 py-6 h-12 rounded-full bg-[#12141d] border-white/10 text-[#f4f1ea] placeholder:text-white/30 focus-visible:ring-[#d95d39]"
          />
          {query && (
            <button
              onClick={() => onQueryChange("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-[#d95d39]"
              aria-label="Clear search"
              data-testid="search-clear-btn"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>

        <div className="flex items-center gap-3">
          <span className="mono-label text-white/40">
            {typeof totalCount === "number" ? `${new Intl.NumberFormat().format(totalCount)} entries` : ""}
          </span>
          <Select value={sort} onValueChange={onSortChange}>
            <SelectTrigger
              data-testid="sort-select"
              className="w-[180px] h-11 rounded-full bg-[#12141d] border-white/10 font-mono-tech text-[11px] uppercase tracking-widest text-white/70"
            >
              <SelectValue placeholder="Sort" />
            </SelectTrigger>
            <SelectContent className="bg-[#12141d] border-white/10 text-[#f4f1ea] font-mono-tech text-xs uppercase tracking-widest">
              {playlistMode && (
                <SelectItem value="playlist">In playlist order</SelectItem>
              )}
              <SelectItem value="newest">Newest first</SelectItem>
              <SelectItem value="oldest">Oldest first</SelectItem>
              <SelectItem value="most_viewed">Most viewed</SelectItem>
              <SelectItem value="longest">Longest</SelectItem>
              <SelectItem value="shortest">Shortest</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="overflow-x-auto custom-scrollbar -mx-4 px-4">
        <div className="flex items-center gap-2 min-w-max" data-testid="category-filter-list">
          {categories.map((cat) => {
            const active = activeCategory === cat.name;
            return (
              <button
                key={cat.name}
                onClick={() => onCategoryChange(cat.name)}
                data-testid={`category-filter-item-${cat.name.replace(/\s+/g, "-").toLowerCase()}`}
                className={`px-4 py-2 rounded-full font-mono-tech text-[11px] uppercase tracking-[0.22em] whitespace-nowrap transition-all ${
                  active
                    ? "bg-[#d95d39] text-white border border-[#d95d39] shadow-lg shadow-[#d95d39]/20"
                    : "bg-white/[0.03] text-white/60 border border-white/10 hover:border-[#d95d39]/60 hover:text-[#f4f1ea]"
                }`}
              >
                {cat.name}
                <span className={`ml-2 ${active ? "text-white/80" : "text-white/30"}`}>{cat.count}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
